export default "__VITE_ASSET__gGJtlI2r__"